export enum ScrollContainerEnum {
  canvas = 'canvas',
  blocksNav = 'blocksNav',
  nodesNav = 'nodesNav',
  toolbar = 'toolbar',
  sectionNav = 'sectionNav',
  tagCollectionNav = 'tagCollectionNav',
}
